// extracted by mini-css-extract-plugin
module.exports = {"root":"AlertPositioner_root__ZROLF"};